import * as Yup from "yup";

export const roadmapItemUpsertSchema = Yup.object({
    name: Yup.string().required("Nome obrigatório."),
    description: Yup.string().optional().nullable(),
    amount: Yup.string().optional().nullable(),
    observation: Yup.string().optional().nullable(),
    deadline: Yup.date().required("Data limite obrigatória"),
});
